export default {
	setMainProduct (state, mainProduct) {
		state.mainProduct = mainProduct;
	},
	setDefaultProductId (state, defaultProductId) {
		state.defaultProductId = defaultProductId;
	},
	setGroupData (state, groupData) {
		state.groupData = groupData;
	},
	setUrlList (state, urlList) {
		state.urlList = urlList;
	},
	setExchanges (state, exchanges) {
		state.exchanges = exchanges;
	},
	setConfigComponentList (state, configComponentList) {
		state.configComponentList = configComponentList;
	},
	setConfigError (state, configError) {
		state.configError = configError;
	},
	setCompability (state, compability) {
		if (compability === 'reset') {
			state.compability = {
				class: 'loading',
				message: 'Laddar',
				shortText: '',
				components: {}
			};
		} else {
			state.compability = compability;
		}
	}
};